import React, { useState, useEffect, useContext } from 'react'
import { Link, useLocation } from "react-router-dom"
import Cookies from 'js-cookie';
import ProductContext from '../context/products/ProductContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { trackAddToCart } from '../utils/pixel.jsx';

function Card({ item, className, type, allFilters, selectedCarEngineId }) {
    const [quantity, setQuantity] = useState(item.stock <= 0 ? 0 : 1);
    const initialStock = item.stock && !isNaN(item.stock) ? item.stock : 0;
    const [cart, setCart] = useState([])


    const location = useLocation();

    const { addToCart,
        getCarName,
        carName
    } = useContext(ProductContext)

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const engineId = queryParams.get('ceng');
        if (selectedCarEngineId) {
            getCarName(selectedCarEngineId)
        }
        else if (engineId) {
            getCarName(engineId)
        }
    }, [])


    const handleInput = (e) => {
        let value = parseInt(e.target.value);

        if (isNaN(value) || value <= 0) {
            value = 1;
        }

        if (value > initialStock) {
            value = initialStock;
        }

        setQuantity(value);
    };

    const handleButtonClick = (action) => {

        setQuantity((prevQuantity) => {
            if (action === 'increment' && prevQuantity < item.stock) {
                return prevQuantity + 1;
            } else if (action === 'decrement' && prevQuantity > 1) {
                return prevQuantity - 1;
            }
            return prevQuantity;
        });
    };

    return (
        <div className={`card bg-base-100 shadow-xl ${className} max-w-[300px] hover:scale-105 hover:shadow-2xl transition-transform transform`}>

            <Link
                className='text-base-content'
                to={item.category == 0 || item.category == 1 ?
                    `/${item.categoryName}/${item.id}` :
                    item.additionalDescription
                        ? `/${item.categoryName}/${item.id}?desc=${encodeURIComponent(item.additionalDescription)}&ceng=${selectedCarEngineId}`
                        : `/${item.categoryName}/${item.id}?ceng=${selectedCarEngineId}`}
            >
                {type && allFilters && <p className='text-center text-gray-400'>{type}</p>}
                <figure className="px-3 pt-10">
                    <img
                        src={item.imageLinks ? item.imageLinks[0]?.imageLink : ''}
                        alt="Shoes"
                        className="rounded-xl w-full h-48 object-contain" />
                </figure>
            </Link>
            <div className="card-body items-center text-center pt-1 pb-2">
                <Link to={item.category == 0 || item.category == 1
                    ? `/${item.categoryName}/${item.id}`
                    : item.additionalDescription
                        ? `/${item.categoryName}/${item.id}?desc=${encodeURIComponent(item.additionalDescription)}&ceng=${selectedCarEngineId}`
                        : `/${item.categoryName}/${item.id}?ceng=${selectedCarEngineId}`}>
                    <h2 className="card-title text-base">{item.title}</h2>
                </Link>
                <div className='tooltip' data-tip={item.additionalDescription}>
                    <p className='text-sm h-[80px]'>
                        {item.additionalDescription ? (
                            <>
                                <span className='text-red-600 font-bold'>Важна напомена: </span>

                                <span className='line-clamp-3'>
                                    {item.additionalDescription}
                                </span>
                            </>
                        ) : ''}
                    </p>
                </div>
                <p className="font-bold text-base">{item.discountedPrice ? <><span className='line-through text-sm font-semibold mr-4 '>{item.price} </span> <span className='text-orange-600'>{item.discountedPrice} ден</span> </> : <span className='mr-4 '>{item.price} ден</span>}</p>
                <div className="flex items-center space-x-4">
                    <div className="py-1 px-1 inline-block bg-white border border-gray-200 rounded-lg dark:bg-neutral-900 dark:border-neutral-700">
                        <div className="flex items-center gap-x-1">
                            <button
                                type="button"
                                className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                tabIndex="-1"
                                aria-label="Decrease"
                                onClick={() => handleButtonClick('decrement')}
                                disabled={item.stock == 0}
                            >
                                <svg className="shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14"></path>
                                </svg>
                            </button>
                            <input
                                id="quantity"
                                type="number"
                                className="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white text-sm"
                                style={{
                                    MozAppearance: 'textfield',
                                    WebkitAppearance: 'none',
                                }}
                                value={quantity}
                                onInput={handleInput}
                                min={1}
                                max={item.stock}
                                disabled={item.stock == 0}
                            />
                            <button
                                type="button"
                                className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                tabIndex="-1"
                                aria-label="Increase"
                                onClick={() => handleButtonClick('increment')}
                                disabled={item.stock == 0}
                            >
                                <svg className="shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div>
                        <button className="btn btn-secondary btn-sm "
                            disabled={item.stock <= 0}
                            onClick={() => {addToCart(item, quantity, carName);trackAddToCart(item.title, item.price)}}>{item.stock <= 0 ? (<span>Нема залиха</span>) : (<span><FontAwesomeIcon icon={faCartShopping} /> Додади во кошничка</span>)}</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Card
